import { render, staticRenderFns } from "./StockPrintBag.vue?vue&type=template&id=13a12be6&scoped=true&"
import script from "./StockPrintBag.vue?vue&type=script&lang=js&"
export * from "./StockPrintBag.vue?vue&type=script&lang=js&"
import style0 from "./StockPrintBag.vue?vue&type=style&index=0&id=13a12be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a12be6",
  null
  
)

export default component.exports